var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Auth } from '@aws-amplify/auth';
import Axios from 'axios';
import { zauvu } from '../config';
export const getSessionJwtToken = () => __awaiter(void 0, void 0, void 0, function* () {
    const session = yield Auth.currentSession();
    return session.getIdToken().getJwtToken();
});
export var UploadType;
(function (UploadType) {
    UploadType["PROFILE_PICTURE"] = "PROFILE_PICTURE";
    UploadType["PUBLIC_RESOURCE"] = "PUBLIC_RESOURCE";
})(UploadType || (UploadType = {}));
export const getSignedUrl = (fileName, fileType, uploadType) => __awaiter(void 0, void 0, void 0, function* () {
    const jwt = yield getSessionJwtToken();
    const resp = yield Axios.post(zauvu.getConfig().S3_SERVICE_URL, {
        fileName,
        fileType,
        uploadType
    }, {
        headers: {
            Authorization: `Bearer ${jwt}`
        }
    });
    return resp.data;
});
export const deleteS3Object = (fileName, fileType, uploadType) => __awaiter(void 0, void 0, void 0, function* () {
    const jwt = yield getSessionJwtToken();
    yield Axios.delete(zauvu.getConfig().S3_SERVICE_URL, {
        data: {
            fileName,
            fileType,
            uploadType
        },
        headers: {
            Authorization: `Bearer ${jwt}`
        }
    });
});
